(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-template"]) return;
  try {
    
	if(template == "product.shippingkit" || template == "product.contactwithslider") {
		variants.splice(0, 1);
		var variantsSelected = [];
		var variantsForSlider = variants;

		console.log(variantsForSlider);

		var slider = document.getElementById('variant-prices-slider');
		var sliderTitle = $('.price-for-kit-w .variant-name'),
				sliderComparePrice = $('.price-for-kit-w .compare_at_price'),
				sliderPrice = $('.price-for-kit-w .regular');

		slider.min = 0;
		slider.value = 0;
		slider.max = variantsForSlider.length - 1;

		if (slider) {
			function changeVariant(index) {
				var slider_index = index;
				sliderTitle.text(variantsForSlider[slider_index].public_title);
				if(variantsForSlider[index].compare_at_price) {
					sliderPrice.text(theme.Currency.formatMoney(variantsForSlider[slider_index].price, theme.moneyFormat));
					sliderComparePrice.text(theme.Currency.formatMoney(variantsForSlider[slider_index].compare_at_price, theme.moneyFormat));
				}
				else {
					sliderComparePrice.text('');
					sliderPrice.text(theme.Currency.formatMoney(variantsForSlider[slider_index].price, theme.moneyFormat));
				}
			}

			$('.single-option-selector').on(
				'change', function()
				{
					var optionName = $(this).attr('data-index');
					var value = $(this).val()
					variantsSelected = variants.filter(function(item)
					{
						return item[optionName] == value;
					});

					if(variantsSelected.length) {
						variantsForSlider = variantsSelected;
					}
					slider.max = variantsForSlider.length - 1;
					slider.value = 0;

					changeVariant(0);
				}
			);

			slider.oninput = function() {
				let slider_index = this.value;
				changeVariant(slider_index);
			}
		}
	}


  } catch(e) { console.error(e); }
})();

})();
